angular.module('mtic.components.dashboards.teacher_general')
.directive('teacherStudentsLeaderboardListing', function (language) {
  return {
    templateUrl: 'template.html',
    restrict: 'E',
    scope: {
      title: '=',
      image: '=',
      available: '=?',
      linkFunc: '=?'
    },
    link: function (scope, element) {

      scope.getTranslation = function(id){
        return language.get(id);
      }

    }
  }
});
